'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _episodechangereport = require('./episodechangereport.html');

var _episodechangereport2 = _interopRequireDefault(_episodechangereport);

var _episodechangereport3 = require('./episodechangereport.controller');

var _episodechangereport4 = _interopRequireDefault(_episodechangereport3);

require('./episodechangereport.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodechangereportComponent = {
  restrict: 'E',
  bindings: {},
  template: _episodechangereport2.default,
  controller: _episodechangereport4.default,
  controllerAs: 'vm'
};

exports.default = episodechangereportComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/episodechangereport/episodechangereport.component.js